import React, { useEffect, useState, createContext, useContext } from 'react';
import { translations, Language, TranslationKey } from './translations';
interface LanguageContextType {
  language: Language;
  setLanguage: (lang: Language) => void;
  t: (key: TranslationKey) => string;
  hasSelectedLanguage: boolean;
}
const LanguageContext = createContext<LanguageContextType | undefined>(undefined);
export function LanguageProvider({
  children
}: {
  children: ReactNode;
}) {
  const [language, setLanguageState] = useState<Language>('en');
  const [hasSelectedLanguage, setHasSelectedLanguage] = useState(false);
  useEffect(() => {
    const savedLang = localStorage.getItem('dab_language') as Language;
    if (savedLang && (savedLang === 'en' || savedLang === 'es')) {
      setLanguageState(savedLang);
      setHasSelectedLanguage(true);
    } else {
      // Try to detect browser language
      const browserLang = navigator.language.toLowerCase();
      if (browserLang.startsWith('es')) {
        setLanguageState('es');
      }
    }
  }, []);
  const setLanguage = (lang: Language) => {
    setLanguageState(lang);
    setHasSelectedLanguage(true);
    localStorage.setItem('dab_language', lang);
  };
  const t = (key: TranslationKey): string => {
    return translations[language][key] || translations['en'][key] || key;
  };
  return <LanguageContext.Provider value={{
    language,
    setLanguage,
    t,
    hasSelectedLanguage
  }} data-id="element-344">
      {children}
    </LanguageContext.Provider>;
}
export function useLanguage() {
  const context = useContext(LanguageContext);
  if (context === undefined) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
}